import { cn } from "./cn";

interface AvatarProps {
  initials: string;
  size?: number;
  square?: boolean;
  color?: string;
  textColor?: string;
  className?: string;
}

export function Avatar({
  initials,
  size = 32,
  square,
  color = "var(--accent-2)",
  textColor = "var(--ink)",
  className,
}: AvatarProps) {
  return (
    <div
      className={cn(
        "grid place-items-center font-display font-black shrink-0",
        square ? "rounded-md" : "rounded-full",
        className,
      )}
      style={{
        width: size,
        height: size,
        background: color,
        color: textColor,
        fontSize: Math.round(size * 0.38),
        letterSpacing: "-0.01em",
      }}
    >
      {initials}
    </div>
  );
}
